
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexb_0CSA9EWmCMMp_45DLCxB334wqDudANATnJprUh2DkkcMeta } from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-ingang/pages/videoSubtitleDictionary/index.vue?macro=true";
import { default as _91no_93FkgMhNTecw6N79j5lHr581TREBxKVARGRifp0P8QMioMeta } from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-ingang/pages/teacher/address-check/[no].vue?macro=true";
import { default as address_45checksYOzt2x969Fbr_45g43LZXfdlhqydO_45GstCMfbw6yF4k20Meta } from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-ingang/pages/teacher/address-checks.vue?macro=true";
import { default as attendanceyRPMr93i2m8graetCApfgkIc1O3dnr6OKdcSNqDkeUgMeta } from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-ingang/pages/teacher/attendance.vue?macro=true";
import { default as notice4DGnxtc_45vM96Q5OKMx_45EIOjb47hTqP1z_KTW3KmnK4EMeta } from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-ingang/pages/teacher/notice.vue?macro=true";
import { default as questiont6_45Oz6I9pAKGisHT_hzrWoRSd2_HqjwP46cOJukMIwUMeta } from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-ingang/pages/teacher/question.vue?macro=true";
import { default as form9wsStXtJnRPx3f7XJHEg66roN5dftrhYZGI0wxL4_voMeta } from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-ingang/pages/shop/form.vue?macro=true";
import { default as index9a2otETxHMqb1RiHHODeLmAyilrOb_qDXk_CXUPqcesMeta } from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-ingang/pages/shop/index.vue?macro=true";
import { default as indexmR6iYvdOsra2s8PTFAIqPtTm9NCwdD2vI3_458nbgSxAQMeta } from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-ingang/pages/sales/withHoldingTax/index.vue?macro=true";
import { default as indexSFfu6oaWlRbZTzntPbZt6cPqm0p78dHKPeYWifHVfo8Meta } from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-ingang/pages/sales/totalTaxType/index.vue?macro=true";
import { default as _91lectureId_930YY_4508F8jS2gTetK_455jn1CF_y8tnV7x_45l4ckUcy7jskMeta } from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-ingang/pages/sales/totalSales/[lectureId].vue?macro=true";
import { default as indexWeWmVJm3wxkxiSogQOvV3YXD0Zdas_45KL7aE9FpzfpgYMeta } from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-ingang/pages/sales/totalSales/index.vue?macro=true";
import { default as boardh9aqOVZgtV3pXFTvJo9CaWcrcgKXDIL2VmC53y8picsMeta } from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-ingang/pages/sales/board.vue?macro=true";
import { default as courseGOn9f770E3ocj9W7uBzmveYkp5_3tCE67DViGNxyUXgMeta } from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/pages/sales/course.vue?macro=true";
import { default as partnerjMSef_45whY3NDlOFkKOh0D3Tw2aisnfP1c9tQUygmdkYMeta } from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-ingang/pages/sales/partner.vue?macro=true";
import { default as teacherJ1TR0dLH2uZRtnTmr8V4EXxJ1cAAa5fxkd4iLpjKhmEMeta } from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-ingang/pages/sales/teacher.vue?macro=true";
import { default as indexkHrQtQ6CBjYhR6mHbAIr_45dhHJ_kqjhB1xx0OhbaBmuIMeta } from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-ingang/pages/media/viewer-error-records/index.vue?macro=true";
import { default as indexMoLzq3f0WQZe6tV3jAeU1NeaWoamTF3nh2Yt3KtkOU4Meta } from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-ingang/pages/media/stw-study-info2s/index.vue?macro=true";
import { default as indexV_45ZTVwb5ND71mDXuk_45d0KBiVKcgX2NBr8WZ4N5jfdRoMeta } from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-ingang/pages/media/stw-mobile-downloads/index.vue?macro=true";
import { default as index0PJgaITty4hk2gMQDKc9aWJ2f5aYSrDXoyGpa7nc3ZgMeta } from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-ingang/pages/media/stw-mobile-devices/index.vue?macro=true";
import { default as indexjq7quTIRMuwrmiRqdibzpPYLLy7vrhgiYLQH9QGohT4Meta } from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-ingang/pages/media/stw-media-connect-log2s/index.vue?macro=true";
import { default as indexX7m24JgJi_45EgoiBICcP_dFLsOac3yuaECdISQu4uByAMeta } from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-ingang/pages/media/stw-device-reset-histories/index.vue?macro=true";
import { default as index7QtZ6e8hvmCltMkj5v4QhiZtohRlvORw04GmacdTF78Meta } from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-ingang/pages/media/stw-concurrent-connect-records/index.vue?macro=true";
import { default as indexbzSyHYQBdp_45l3X4qIPDqFpKXKXdQaW_MuYHkjQC55rQMeta } from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-ingang/pages/media/movie-file-error-logs/index.vue?macro=true";
import { default as autoRegisterPgRQ4BVwWQTuyCb63GzquF5VYhfZ85HyLYIqS0sKEYMMeta } from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-ingang/pages/events/autoRegister.vue?macro=true";
import { default as issued9nLYhaKDTwWcDQgKI8FXb5ZhOUIN3GTrhTcv95t1UbAMeta } from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-ingang/pages/events/issued.vue?macro=true";
import { default as listxJ7aSRopRD1Aawq5BlNMi3y6sNp_457hGJEKdy1SA_tY0Meta } from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-ingang/pages/events/list.vue?macro=true";
import { default as pointAByy9DKARTrImvgwcZj0BMqcn0OhsTxdax8bbZuD6JcMeta } from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-ingang/pages/events/point.vue?macro=true";
import { default as starCashn_5gQIa2x_45CKpZT_PCaBczkSboqpUJJX3u5dWGZUqs4Meta } from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-ingang/pages/events/starCash.vue?macro=true";
import { default as formrDE_45VXWT7HjiQMwizLuTNCp5fkO_45mbSqpuDthD5D1dkMeta } from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-ingang/pages/design/designFrame/form.vue?macro=true";
import { default as indexk_EmfPpYtb3lZY11Ie1GpcYPAkRLMF0boZ4huSJuMRwMeta } from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-ingang/pages/design/designFrame/index.vue?macro=true";
import { default as _91pk_93Ex3VaSSh3ZOUD__45XtWgZz7W2pViGQipswGPQBRqIy0IMeta } from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/pages/design/designCustomized/[type]/[pk].vue?macro=true";
import { default as _91pk_939dlrz_NQ0I1xkRsy2pUWzZQq7s4oiDTBUeMneWkx1HIMeta } from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/pages/design/designCustomized/form/[type]/[pk].vue?macro=true";
import { default as _91courseInfoNo_93BuwWe0YaeugbzPzSt3JPF3fW5OkzeJ87nDKG8J27BVEMeta } from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-ingang/pages/courseInfo/allLecture/[courseInfoNo].vue?macro=true";
import { default as formvGDlLn9mFDb3zIy2SHEZKDFWCV_45u3kWPyky2ACZ9UAUMeta } from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-ingang/pages/courseInfo/form.vue?macro=true";
import { default as groupRegRZb94WXkdkxDRrnEfg_N3WVefwd2d7uwfMfKu9E5z_45YMeta } from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-ingang/pages/courseInfo/groupReg.vue?macro=true";
import { default as index_pvRj_45tLMrfqNm192gdDnlZd3xT1ys9rCuaWV_qDI6QMeta } from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-ingang/pages/courseInfo/index.vue?macro=true";
import { default as writeo0fZ59QilAgSv9W7_BsLHCJL9CR4e3U30ONfzXbT_45dgMeta } from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-ingang/pages/course/regular/write.vue?macro=true";
import { default as _91typedPk_93etrMvqjjHo5l2_45TkLikm_3_5WJc80YNNjxJp1q65bH8Meta } from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/pages/course/package/[typedPk].vue?macro=true";
import { default as indexqLAXtDUM5YeOf2p2LpuUGRnJ0Usv1F6hupxcL8coDLsMeta } from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-ingang/pages/course/mini/index.vue?macro=true";
import { default as writergO41SKOiMjYZVWex5s_nwkr2N46LzWAfs3Kv44qETUMeta } from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-ingang/pages/course/mini/write.vue?macro=true";
import { default as _91typedPk_932VM2Oo95rzrJSZ8YoGqVD9RijKH3bqmpzlhVoyhTXBsMeta } from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-ingang/pages/course/lectureList/[typedPk].vue?macro=true";
import { default as indexstSDra77jsTbao4AdHvPrz3dLFvjCygfd04zMi_45_458wMMeta } from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-ingang/pages/course/lectureIcon/index.vue?macro=true";
import { default as issuedJw17mLpRD1nClxyhQhhWAHoNaxecUUNpJq819wN1OP8Meta } from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/pages/coupon/issued.vue?macro=true";
import { default as templateI4wdQEHkll5TkMscmJyGT_6ul7WNC30NJJCdJBpbA1MMeta } from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/pages/coupon/template.vue?macro=true";
import { default as data_45roomqZ4oSdqA01rQTESir3xUbTGAbw8xblXgv1sjBDY0XlwMeta } from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-ingang/pages/bookstore/data-room.vue?macro=true";
import { default as formCcxderkbgHn_AjRh8H_ZFOh3ptSh2ZbHopv1RF2vkjQMeta } from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-ingang/pages/bookstore/form.vue?macro=true";
import { default as indexkERHf50_45Lxw_Sv_45CEfsAwVYpvbtPo0TifCZHFWUJPdwMeta } from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-ingang/pages/bookstore/index.vue?macro=true";
import { default as _91no_93_45gEmqBHcqiXcp8paZ7xg6UmyeEffu3qcXfLd1_45fpk3AMeta } from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-doyac/pages/users/expired/[no].vue?macro=true";
import { default as indexNQ_45te8oqTBtw3_45VKsxH_0jHVzI_wmBO0xtcdcVaCkbAMeta } from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-doyac/pages/users/expired/index.vue?macro=true";
import { default as indexamOsP6_45x3cCXlmoIrBlbRkKaoJs6ZyVGxtfL65ZzKwkMeta } from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-doyac/pages/users/delmember/index.vue?macro=true";
import { default as _91no_93NlCN_45MbjzuiH7VLMfjpVPunqVCeVkKOsTVpuET0GooAMeta } from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/pages/users/[no].vue?macro=true";
import { default as blackIdcTeIoNAKLWiIv1k8_452gEATCH3HgeiO9ZIfNv63oKa6oMeta } from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-ingang/pages/users/blackId.vue?macro=true";
import { default as blackIpXIV71Um4kT8YW0aJxIjFPVyxoQZ36tiEnWXcLVZ5DmsMeta } from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-doyac/pages/users/blackIp.vue?macro=true";
import { default as blackIpCapchapHeT_459Vgqas9J5It7LcV8nCssQGruopXUzdgscbiVZEMeta } from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-doyac/pages/users/blackIpCapcha.vue?macro=true";
import { default as indexSSgsCuuJRMPEnNdMtZxrHTGps14YV95nacSg4SRdQ88Meta } from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-doyac/pages/users/index.vue?macro=true";
import { default as loginHistoryn9cdKDf9VbjszTTCB_fyCPa8epO2G4O7NGwG6FUvPHwMeta } from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/pages/users/loginHistory.vue?macro=true";
import { default as suspiciousz175zu2S9CjXnY4zXKRZChZ_qAa3ot6gnDEEPNTJOoEMeta } from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-doyac/pages/users/suspicious.vue?macro=true";
import { default as wrongNumberDt8yWn5rGOs6IdOlVhNIsD430yTQZAmyb5ccilReO1cMeta } from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-ingang/pages/users/wrongNumber.vue?macro=true";
import { default as wrongNumberHistoryh6BxkAFwUCjh_IRNEDktnunQ_RBfMRJ52je15lqtDYoMeta } from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-ingang/pages/users/wrongNumberHistory.vue?macro=true";
import { default as index18NFtVoUAFxA0NqXlWSnBlMphvwJAcOWtpM9La2FtiAMeta } from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-doyac/pages/upcomingWork/index.vue?macro=true";
import { default as indexVAfjRohZKbWTJtUEYu4ihMRHoW6pAHugVFwmMsi83Z0Meta } from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-doyac/pages/toExpense/index.vue?macro=true";
import { default as aBHAQwbyz6Ehb4KFE_iYtx9FPdUjQntiBsXXbjk6s0bEMeta } from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-doyac/pages/test/a.vue?macro=true";
import { default as bcD4UqvmHK46YUjSlv1bTKmIP5_wiEk_8I3ZRwnpdxmsMeta } from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-doyac/pages/test/b.vue?macro=true";
import { default as ea08Lwdbw3Ird4meKNkYV2Bn3vWU2sRxcRoeHcsgVixYcMeta } from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-doyac/pages/test/ea.vue?macro=true";
import { default as logAdIpGroupZ2Mt_spFxgZK5L7Z_457yXn671kL4D7RsPLFYvFwA_NjsMeta } from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-doyac/pages/siteManage/logAdIpGroup.vue?macro=true";
import { default as logAdVsPayIfJK58J0ArrI9wRGpIKNoAmROqGbKpKdWflPZ6KZGRYMeta } from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-doyac/pages/siteManage/logAdVsPay.vue?macro=true";
import { default as mongoLogNT2zbiAONgr7UVeyqSBbiNPMrXweUom2Vsn4DpTaMxoMeta } from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-doyac/pages/siteManage/mongoLog.vue?macro=true";
import { default as personalQnac22sovHBQpXtMnpdvGJq_45b4MNTF1lsb0o1ZQm0khH2MMeta } from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-doyac/pages/siteManage/personalQna.vue?macro=true";
import { default as quickRepliescl1sO_WgPWNNcR4OWcJlHZi5awKRyDlZymbs5exOZ5AMeta } from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-doyac/pages/siteManage/quickReplies.vue?macro=true";
import { default as reviewsuxOB0V9VHlC5Gn0X5h8b_FD8RNSmSj_453OGqpcjGVFicMeta } from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-ingang/pages/siteManage/reviews.vue?macro=true";
import { default as serverSchedule1sBG_45HFtQxD7mqpPI83ZhDSIceIf2RUgyJ3LWA6oLRYMeta } from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-ingang/pages/siteManage/serverSchedule.vue?macro=true";
import { default as serverSettingDyN6IPXusapuTr_fC1e3KEf_45Sy_45hPlMF7B6eX70DdskMeta } from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-ingang/pages/siteManage/serverSetting.vue?macro=true";
import { default as questionsyO5IE4zvSqb7KWwHTYUYsH9dtsfy_45y72GWmoeZ6_xEMMeta } from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-doyac/pages/research/[typedPk]/questions.vue?macro=true";
import { default as indexZe3_WMvkwIdgcpaeIViU6ZD_45fDoR4_bE9cKbbkILkSUMeta } from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-doyac/pages/research/index.vue?macro=true";
import { default as indexqqm1qny5yuazBah3jqBy1mR3PKxOh7Nf2EkimuQYAsAMeta } from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-doyac/pages/reminder/index.vue?macro=true";
import { default as _91no_93x7tg8lIuoVKox0AvQ_1sP8agLnRLotRAMyvCAQeFC3UMeta } from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-ingang/pages/payments/[table]/[no].vue?macro=true";
import { default as indexVZSDkdYjJ9gn8W3Rlu1JUZ79anMp7zb_GsGZJucoLmwMeta } from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-ingang/pages/payments/[table]/index.vue?macro=true";
import { default as _91no_93YfYCBlXFhdrbeHREAYlixyAtObMnIb6DLmt8CNQ8ufAMeta } from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-ingang/pages/payments/shops/[no].vue?macro=true";
import { default as indexrvOT0_K7PlELjIASsRz21AXf9rx9dgsyB_454ayXQvrB4Meta } from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-ingang/pages/payments/shops/index.vue?macro=true";
import { default as _91no_93QNKxTLTWcfPxuZKKBiUs9t9poC_45tI7hSBHgikdeaeMMMeta } from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-ingang/pages/payments/licenses-judgement/[no].vue?macro=true";
import { default as _91no_93SWktAPsUQ_4551fRCwUwXItokIH6XDR3lS4FETMaSenhUMeta } from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-ingang/pages/payments/licenses/[no].vue?macro=true";
import { default as indexcjoXzWHL0agJw6_f2NyuZjGEn1SskS3ng30xB_45FE7qQMeta } from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-ingang/pages/payments/licenses/index.vue?macro=true";
import { default as _91no_93rXbIdbHhLX4WKmt50DwI2ZdrnrgNAKIIoL_45t3_45SqZWgMeta } from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-ingang/pages/payments/courses/[no].vue?macro=true";
import { default as index7rqxuJMzJujpdHfN6MRyT1Wm_P_45AGJ0JuBbXd6jHCu4Meta } from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-ingang/pages/payments/courses/index.vue?macro=true";
import { default as _91no_93JCtq4XN0eez6dHRcd1adFvcw00b9yv4aI73p2NyZ9QkMeta } from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-ingang/pages/payments/books/[no].vue?macro=true";
import { default as index5MdK_gUhFUTetD_ZCTDWva2dshEE7Ykt10XAdVBSqsoMeta } from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-ingang/pages/payments/books/index.vue?macro=true";
import { default as _91no_938Z2fBoz_45DtYD1AC9B6olWgeYL9B3TwLHVLHc9AVyTw8Meta } from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-doyac/pages/payments/manual-payments/[no].vue?macro=true";
import { default as indexqz014EHP6j5atjL6EdHoUf4NfPmx4ulB8vRIoC3BgvEMeta } from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-doyac/pages/payments/manual-payments/index.vue?macro=true";
import { default as index2YlMR7FKgCoed32ky62twNDAcU020TCLvYrD_45bLixFQMeta } from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-doyac/pages/payments/deposit/index.vue?macro=true";
import { default as index6dtt_NFoGQeI2Smr_45lvTkdJ8zKMg1K0NM6zzYCFu_456gMeta } from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-doyac/pages/payments/coupang/index.vue?macro=true";
import { default as index8ZCU4RpzNH12TuD05xFFAGfzrELtyUfrlfnZjXD3xy0Meta } from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-doyac/pages/payments/cash-receipts/index.vue?macro=true";
import { default as help_45requestFAYl0qIBk0wJVCFr_Yp_n4KzaqG0NHeK7EDvE3adXsQMeta } from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-doyac/pages/payments/help-request.vue?macro=true";
import { default as openBellListmCxC5jmBTWyeelz8nQJHFl0xU4Bw99bF871TdKkszWkMeta } from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-ingang/pages/payments/openBellList.vue?macro=true";
import { default as indexp95SR3uqdH5boNv4mxR7lb_45KdusSg1Jdsf9sIQG0UFgMeta } from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-doyac/pages/p1/p2/index.vue?macro=true";
import { default as index9o4ikYapQ6HhuDgAdsf2Ygms97wnWGeaXAVRe1BATBQMeta } from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-doyac/pages/p1/index.vue?macro=true";
import { default as index96HuUAvx_KSaIMUfnZtOLWvJ2GouGd47MbSWLqkSNrcMeta } from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/pages/message/index.vue?macro=true";
import { default as indexaRbAK4kTDA2Oy9sdY9if__G0B3cUfQd3SbqY5zLuDcQMeta } from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-doyac/pages/mail/index.vue?macro=true";
import { default as writeiNuamx4H1e1hOt5Te0kweKkZoPIXO7_454b76wp2_RR5sMeta } from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-doyac/pages/mail/write.vue?macro=true";
import { default as _91scope_93CJCsZF3lC96cesb9WoHt_45XYZIjirdNMpN8cIk7n7LAEMeta } from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-doyac/pages/login/[scope].vue?macro=true";
import { default as index2M8M8_J3EJjSGw4LIFEmCRGeyYpt4GA7cATGQ96MkuQMeta } from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-doyac/pages/login/index.vue?macro=true";
import { default as _91id_93pZemD0W7J2wmqN3zr2Lx9daju_45tEJnT1y5ceA77PZoYMeta } from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-doyac/pages/holidayManage/[id].vue?macro=true";
import { default as index1JuHgtc9yWGh49NpInHHaXcv1y5H4MLKawruyANXIckMeta } from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-doyac/pages/holidayManage/index.vue?macro=true";
import { default as autoEventForStudentVlaUEwLvu8qw9ZSJz2NPUDisP7TUyQCNAwgGIfRf_45cgMeta } from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-ingang/pages/engineer/autoEventForStudent.vue?macro=true";
import { default as siteSettingbBfJ7rGMFigltEltWEum4O6ObyDhLhLABveeR66riXQMeta } from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-doyac/pages/engineer/siteSetting.vue?macro=true";
import { default as _91no_93k4EMQJCpKoDrgNArzip6QLEiEhTbSiiBdi1c6WZZPWoMeta } from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-doyac/pages/email/inbox/[no].vue?macro=true";
import { default as indexOj6zfHu9WiSXrkzH5oDihMjBnc0humdC_Rfs7_453eahcMeta } from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-doyac/pages/email/inbox/index.vue?macro=true";
import { default as _91type_93CgKapbyMH4IhL7PbYv3TtYw3Yj_45gA_ZY7u3XdN6yHUAMeta } from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-doyac/pages/electronicAuthorization/write/[type].vue?macro=true";
import { default as _91no_93aort42eQ_uM2JMM7M4VARxYJ0dqEJkDO_43qxLuPzwEMeta } from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-doyac/pages/electronicAuthorization/[no].vue?macro=true";
import { default as indexqMu9PW_03mNEoNgRroHjZqtKkwZMlg_45AhoA7ee41hlgMeta } from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-doyac/pages/electronicAuthorization/index.vue?macro=true";
import { default as _91id_93BAFzw5IKLYaZ3lecDhsziulsd99pxExC2UnsxQWmNVYMeta } from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-doyac/pages/commuteRecord/[id].vue?macro=true";
import { default as indexyOj8kJDUC1dYFxW06AKCrIiI7wn6kLMe68iyoBd24MwMeta } from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-doyac/pages/commuteRecord/index.vue?macro=true";
import { default as _91no_93oEeyW390FhUwGPmytD9WzyGLkTFxWbYTTZlH_U5OslQMeta } from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-doyac/pages/calendar/[no].vue?macro=true";
import { default as _91no_93Tw_p_45OPvGhsnyJUI0s4VNAZ2Ak9P6s4u6N1aV7rzf04Meta } from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-doyac/pages/aiProposal/[no].vue?macro=true";
import { default as index_451m_hmVA9J6mHPS2OsPHWsKGITTs4LRelZvZz082wtwMeta } from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-doyac/pages/aiProposal/index.vue?macro=true";
import { default as _91no_93JfgA_cuu6TrbKTHeyc6YA_45tVECy6zTOZpoiInnqIcjMMeta } from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-doyac/pages/admin/notice/[no].vue?macro=true";
import { default as form1ogCCvznW2C6oja7i3TRV5H1F3MGUi_Vt12j48dOWnUMeta } from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-doyac/pages/admin/notice/form.vue?macro=true";
import { default as indexsylDSRXirWXB6_456fyJvwBdmpaptEMUb_451ArgGqX5S_kMeta } from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-doyac/pages/admin/notice/index.vue?macro=true";
import { default as boardManagerKvaqeMIQVWSHqY_gjuxrthBaXv83lp3bdQkbdyjfCrkMeta } from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-doyac/pages/admin/boardManager.vue?macro=true";
import { default as boardRankingt_XWRGpAr3_45lka3oJMvVx3sI3yOMTvcJrDCCVxnoukkMeta } from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-doyac/pages/admin/boardRanking.vue?macro=true";
import { default as ai5aPSvHlOnXf5f7QHj5kjIXEITv_WRRSdp3njquU0JgEMeta } from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-doyac/pages/ai.vue?macro=true";
import { default as app_45bugs4t9m18XtUyH_45_45bT4d4TL3MSdERsK6h3EM2eafwfz9BMMeta } from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-ingang/pages/app-bugs.vue?macro=true";
import { default as banners8z5lxyDIPVdHUWzIG4xjfudGLSgvAfJ9trgzZr_45B9kUMeta } from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-doyac/pages/banners.vue?macro=true";
import { default as bugsm00pKnhJTvLv22mZKNmUYTF9vMAHln8Jpvys_450rNyckMeta } from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-ingang/pages/bugs.vue?macro=true";
import { default as errorawbGuZ9JxL8f3kUBGFHheYC6UtFJiAal2RPf4TIJkGYMeta } from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-doyac/pages/error.vue?macro=true";
import { default as indexYVeA_s0_KaLd_LN4FKvb_45NG15bBj7wNZTqKfyfpOfY8Meta } from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/pages/index.vue?macro=true";
import { default as infob_45AqWMOhag8i1dRMlQiwY1wCS7tL8tYfaM0aTMg9J6AMeta } from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/pages/cities/info.vue?macro=true";
import { default as emailAccountaQ7Ip0UF72mG0lYCQiG4FNeOG35TTUWYK5fNW0N6bBoMeta } from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/pages/emailAccount.vue?macro=true";
import { default as indexF5wmmFvK2k9PlsIY6gIEX0GdQiiRzCtbgjliqnrxW_AMeta } from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/pages/nations/index.vue?macro=true";
import { default as mapsaTwXh8CRci_7tD5g_45agcfUPtXsna3258f2OcoKOAruQMeta } from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/pages/tourguide/maps.vue?macro=true";
import { default as indexP2EiL0FR6l7_1WahFdxL7_45u9XsbSlyEd_45yRSX4ditVEMeta } from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/pages/info-urls/index.vue?macro=true";
import { default as _91city_9338Kyg9GlOGCNobvEYs33NJbJbfzYzpcKxjWe_mhbKgAMeta } from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/pages/tourguide/[city].vue?macro=true";
import { default as _91isoCode2_93AjSIzW2N8L_hy_YqGa_45b7cz8UWivQLSBYoMElG2NAqkMeta } from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/pages/cities/[isoCode2].vue?macro=true";
import { default as index1kuNrnlIvHvHIsgKMZawUinHX3Q7UIaTu0E4L9ci45AMeta } from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/pages/tour-shares/index.vue?macro=true";
import { default as indexByCz3P1bwkipX1RnCLGGh2Pihd5cgwD063KdkBC_45dAcMeta } from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/pages/change-infos/index.vue?macro=true";
import { default as indexA8VREIJGm8VkeucRFERn2jFVdIdRRx2PWo3go7GitCIMeta } from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/pages/route-reports/index.vue?macro=true";
import { default as _91no_93ugRDf3bK3VeagjFfv9aeic4gfYbVIEIYRp7wcC4vYJUMeta } from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/pages/payments/tickets/[no].vue?macro=true";
import { default as indexyqaQxnSZP8OVcr1ljoFQS_EiJAO7lMl07EJY7kVGsZYMeta } from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/pages/payments/tickets/index.vue?macro=true";
import { default as _91city_93uLe4C6FMlZr2wB4wTE7OCxRG2nhhIY9U6IT_45yBYSvkgMeta } from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/pages/tourguide/write/[city].vue?macro=true";
import { default as _91no_93yIRPKGQETJvfwuF6juixhwVxVBw_aphASa_45QLCnedc4Meta } from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/pages/payments/gift-orders/[no].vue?macro=true";
import { default as _91no_93Dqwgv8_45ACeOYDWl7ExRo47oWbhMrv_UrxzNq9NP7owMMeta } from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/pages/payments/tour-guides/[no].vue?macro=true";
import { default as index1o8g9R9LECvgOM6_45WWjWY6LdKdpbZBKyVgPi1qWo6p0Meta } from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/pages/payments/gift-orders/index.vue?macro=true";
import { default as indexPwMxCm8FkzxSIylm03yF9SNUx6iZMEu0nZBbgzDD5a8Meta } from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/pages/payments/tour-guides/index.vue?macro=true";
import { default as _91no_93Z9c_w_454HvLHyA6zu5hMf8TzXmobCVGjBeakjx6rcd_8Meta } from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/pages/ticket-product-frames/[no].vue?macro=true";
import { default as _91contentsNo_93x8187iQGZMGpLzhupCmJKjHo3ZXWhWgIbCCJqtTYGoQMeta } from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/pages/tourguide/pds/[contentsNo].vue?macro=true";
import { default as indexv322BXpCAOjT_6Uw1eQRP1xJ26lSiBJgbIwl7kvy0D8Meta } from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/pages/tourguide/thirdParty/index.vue?macro=true";
import { default as new8GVPS9cZp_45f6pvZzPE7_45VJmZNXOi_DUQAbVjPylkmwgMeta } from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/pages/ticket-product-contents/new.vue?macro=true";
import { default as indexdyNidm6yKvoCuiXIMaeMBLdhRHD377elV8cdQAGqKTMMeta } from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/pages/ticket-product-frames/index.vue?macro=true";
import { default as _91no_93kZfoGH2jOCq8nfXUBijpmSOqM9LdpdRb006lpE8LG8YMeta } from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/pages/ticket-product-contents/[no].vue?macro=true";
import { default as _91contentsNo_938QlCc6LvJYMpFV4QVOfBPZcYhVV_hMlx5R8FQRbiLTYMeta } from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/pages/tourguide/route/[contentsNo].vue?macro=true";
import { default as _91no_93qTuVVOZETCnwuXwmVmWMW6h0_45fAlnrHYOMcfTjGjjuIMeta } from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/pages/tourguide/write/contents/[no].vue?macro=true";
import { default as _91typedPk_9353j2KLnA75d23adkTD1mETfWShAnNxa9aoFzxVKabk4Meta } from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/pages/tourguide/thirdParty/[typedPk].vue?macro=true";
import { default as _91contentsNo_933x9Tn1ARKCNLguGHjZKqNjayGY_45QrLjBzu6L01Rc6osMeta } from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/pages/tourguide/write/route/[contentsNo].vue?macro=true";
export default [
  {
    name: "videoSubtitleDictionary",
    path: "/videoSubtitleDictionary",
    meta: indexb_0CSA9EWmCMMp_45DLCxB334wqDudANATnJprUh2DkkcMeta || {},
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-ingang/pages/videoSubtitleDictionary/index.vue")
  },
  {
    name: "teacher-address-check-no",
    path: "/teacher/address-check/:no()",
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-ingang/pages/teacher/address-check/[no].vue")
  },
  {
    name: "teacher-address-checks",
    path: "/teacher/address-checks",
    meta: address_45checksYOzt2x969Fbr_45g43LZXfdlhqydO_45GstCMfbw6yF4k20Meta || {},
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-ingang/pages/teacher/address-checks.vue")
  },
  {
    name: "teacher-attendance",
    path: "/teacher/attendance",
    meta: attendanceyRPMr93i2m8graetCApfgkIc1O3dnr6OKdcSNqDkeUgMeta || {},
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-ingang/pages/teacher/attendance.vue")
  },
  {
    name: "teacher-notice",
    path: "/teacher/notice",
    meta: notice4DGnxtc_45vM96Q5OKMx_45EIOjb47hTqP1z_KTW3KmnK4EMeta || {},
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-ingang/pages/teacher/notice.vue")
  },
  {
    name: "teacher-question",
    path: "/teacher/question",
    meta: questiont6_45Oz6I9pAKGisHT_hzrWoRSd2_HqjwP46cOJukMIwUMeta || {},
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-ingang/pages/teacher/question.vue")
  },
  {
    name: "shop-form",
    path: "/shop/form",
    meta: form9wsStXtJnRPx3f7XJHEg66roN5dftrhYZGI0wxL4_voMeta || {},
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-ingang/pages/shop/form.vue")
  },
  {
    name: "shop",
    path: "/shop",
    meta: index9a2otETxHMqb1RiHHODeLmAyilrOb_qDXk_CXUPqcesMeta || {},
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-ingang/pages/shop/index.vue")
  },
  {
    name: "sales-withHoldingTax",
    path: "/sales/withHoldingTax",
    meta: indexmR6iYvdOsra2s8PTFAIqPtTm9NCwdD2vI3_458nbgSxAQMeta || {},
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-ingang/pages/sales/withHoldingTax/index.vue")
  },
  {
    name: "sales-totalTaxType",
    path: "/sales/totalTaxType",
    meta: indexSFfu6oaWlRbZTzntPbZt6cPqm0p78dHKPeYWifHVfo8Meta || {},
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-ingang/pages/sales/totalTaxType/index.vue")
  },
  {
    name: "sales-totalSales-lectureId",
    path: "/sales/totalSales/:lectureId()",
    meta: _91lectureId_930YY_4508F8jS2gTetK_455jn1CF_y8tnV7x_45l4ckUcy7jskMeta || {},
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-ingang/pages/sales/totalSales/[lectureId].vue")
  },
  {
    name: "sales-totalSales",
    path: "/sales/totalSales",
    meta: indexWeWmVJm3wxkxiSogQOvV3YXD0Zdas_45KL7aE9FpzfpgYMeta || {},
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-ingang/pages/sales/totalSales/index.vue")
  },
  {
    name: "sales-board",
    path: "/sales/board",
    meta: boardh9aqOVZgtV3pXFTvJo9CaWcrcgKXDIL2VmC53y8picsMeta || {},
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-ingang/pages/sales/board.vue")
  },
  {
    name: "sales-course",
    path: "/sales/course",
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/pages/sales/course.vue")
  },
  {
    name: "sales-partner",
    path: "/sales/partner",
    meta: partnerjMSef_45whY3NDlOFkKOh0D3Tw2aisnfP1c9tQUygmdkYMeta || {},
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-ingang/pages/sales/partner.vue")
  },
  {
    name: "sales-teacher",
    path: "/sales/teacher",
    meta: teacherJ1TR0dLH2uZRtnTmr8V4EXxJ1cAAa5fxkd4iLpjKhmEMeta || {},
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-ingang/pages/sales/teacher.vue")
  },
  {
    name: "media-viewer-error-records",
    path: "/media/viewer-error-records",
    meta: indexkHrQtQ6CBjYhR6mHbAIr_45dhHJ_kqjhB1xx0OhbaBmuIMeta || {},
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-ingang/pages/media/viewer-error-records/index.vue")
  },
  {
    name: "media-stw-study-info2s",
    path: "/media/stw-study-info2s",
    meta: indexMoLzq3f0WQZe6tV3jAeU1NeaWoamTF3nh2Yt3KtkOU4Meta || {},
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-ingang/pages/media/stw-study-info2s/index.vue")
  },
  {
    name: "media-stw-mobile-downloads",
    path: "/media/stw-mobile-downloads",
    meta: indexV_45ZTVwb5ND71mDXuk_45d0KBiVKcgX2NBr8WZ4N5jfdRoMeta || {},
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-ingang/pages/media/stw-mobile-downloads/index.vue")
  },
  {
    name: "media-stw-mobile-devices",
    path: "/media/stw-mobile-devices",
    meta: index0PJgaITty4hk2gMQDKc9aWJ2f5aYSrDXoyGpa7nc3ZgMeta || {},
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-ingang/pages/media/stw-mobile-devices/index.vue")
  },
  {
    name: "media-stw-media-connect-log2s",
    path: "/media/stw-media-connect-log2s",
    meta: indexjq7quTIRMuwrmiRqdibzpPYLLy7vrhgiYLQH9QGohT4Meta || {},
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-ingang/pages/media/stw-media-connect-log2s/index.vue")
  },
  {
    name: "media-stw-device-reset-histories",
    path: "/media/stw-device-reset-histories",
    meta: indexX7m24JgJi_45EgoiBICcP_dFLsOac3yuaECdISQu4uByAMeta || {},
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-ingang/pages/media/stw-device-reset-histories/index.vue")
  },
  {
    name: "media-stw-concurrent-connect-records",
    path: "/media/stw-concurrent-connect-records",
    meta: index7QtZ6e8hvmCltMkj5v4QhiZtohRlvORw04GmacdTF78Meta || {},
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-ingang/pages/media/stw-concurrent-connect-records/index.vue")
  },
  {
    name: "media-movie-file-error-logs",
    path: "/media/movie-file-error-logs",
    meta: indexbzSyHYQBdp_45l3X4qIPDqFpKXKXdQaW_MuYHkjQC55rQMeta || {},
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-ingang/pages/media/movie-file-error-logs/index.vue")
  },
  {
    name: "events-autoRegister",
    path: "/events/autoRegister",
    meta: autoRegisterPgRQ4BVwWQTuyCb63GzquF5VYhfZ85HyLYIqS0sKEYMMeta || {},
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-ingang/pages/events/autoRegister.vue")
  },
  {
    name: "events-issued",
    path: "/events/issued",
    meta: issued9nLYhaKDTwWcDQgKI8FXb5ZhOUIN3GTrhTcv95t1UbAMeta || {},
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-ingang/pages/events/issued.vue")
  },
  {
    name: "events-list",
    path: "/events/list",
    meta: listxJ7aSRopRD1Aawq5BlNMi3y6sNp_457hGJEKdy1SA_tY0Meta || {},
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-ingang/pages/events/list.vue")
  },
  {
    name: "events-point",
    path: "/events/point",
    meta: pointAByy9DKARTrImvgwcZj0BMqcn0OhsTxdax8bbZuD6JcMeta || {},
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-ingang/pages/events/point.vue")
  },
  {
    name: "events-starCash",
    path: "/events/starCash",
    meta: starCashn_5gQIa2x_45CKpZT_PCaBczkSboqpUJJX3u5dWGZUqs4Meta || {},
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-ingang/pages/events/starCash.vue")
  },
  {
    name: "design-designFrame-form",
    path: "/design/designFrame/form",
    meta: formrDE_45VXWT7HjiQMwizLuTNCp5fkO_45mbSqpuDthD5D1dkMeta || {},
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-ingang/pages/design/designFrame/form.vue")
  },
  {
    name: "design-designFrame",
    path: "/design/designFrame",
    meta: indexk_EmfPpYtb3lZY11Ie1GpcYPAkRLMF0boZ4huSJuMRwMeta || {},
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-ingang/pages/design/designFrame/index.vue")
  },
  {
    name: "design-designCustomized-type-pk",
    path: "/design/designCustomized/:type()/:pk()",
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/pages/design/designCustomized/[type]/[pk].vue")
  },
  {
    name: "design-designCustomized-form-type-pk",
    path: "/design/designCustomized/form/:type()/:pk()",
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/pages/design/designCustomized/form/[type]/[pk].vue")
  },
  {
    name: "courseInfo-allLecture-courseInfoNo",
    path: "/courseInfo/allLecture/:courseInfoNo()",
    meta: _91courseInfoNo_93BuwWe0YaeugbzPzSt3JPF3fW5OkzeJ87nDKG8J27BVEMeta || {},
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-ingang/pages/courseInfo/allLecture/[courseInfoNo].vue")
  },
  {
    name: "courseInfo-form",
    path: "/courseInfo/form",
    meta: formvGDlLn9mFDb3zIy2SHEZKDFWCV_45u3kWPyky2ACZ9UAUMeta || {},
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-ingang/pages/courseInfo/form.vue")
  },
  {
    name: "courseInfo-groupReg",
    path: "/courseInfo/groupReg",
    meta: groupRegRZb94WXkdkxDRrnEfg_N3WVefwd2d7uwfMfKu9E5z_45YMeta || {},
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-ingang/pages/courseInfo/groupReg.vue")
  },
  {
    name: "courseInfo",
    path: "/courseInfo",
    meta: index_pvRj_45tLMrfqNm192gdDnlZd3xT1ys9rCuaWV_qDI6QMeta || {},
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-ingang/pages/courseInfo/index.vue")
  },
  {
    name: "course-regular-write",
    path: "/course/regular/write",
    meta: writeo0fZ59QilAgSv9W7_BsLHCJL9CR4e3U30ONfzXbT_45dgMeta || {},
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-ingang/pages/course/regular/write.vue")
  },
  {
    name: "course-package-typedPk",
    path: "/course/package/:typedPk()",
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/pages/course/package/[typedPk].vue")
  },
  {
    name: "course-mini",
    path: "/course/mini",
    meta: indexqLAXtDUM5YeOf2p2LpuUGRnJ0Usv1F6hupxcL8coDLsMeta || {},
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-ingang/pages/course/mini/index.vue")
  },
  {
    name: "course-mini-write",
    path: "/course/mini/write",
    meta: writergO41SKOiMjYZVWex5s_nwkr2N46LzWAfs3Kv44qETUMeta || {},
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-ingang/pages/course/mini/write.vue")
  },
  {
    name: "course-lectureList-typedPk",
    path: "/course/lectureList/:typedPk()",
    meta: _91typedPk_932VM2Oo95rzrJSZ8YoGqVD9RijKH3bqmpzlhVoyhTXBsMeta || {},
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-ingang/pages/course/lectureList/[typedPk].vue")
  },
  {
    name: "course-lectureIcon",
    path: "/course/lectureIcon",
    meta: indexstSDra77jsTbao4AdHvPrz3dLFvjCygfd04zMi_45_458wMMeta || {},
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-ingang/pages/course/lectureIcon/index.vue")
  },
  {
    name: "coupon-issued",
    path: "/coupon/issued",
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/pages/coupon/issued.vue")
  },
  {
    name: "coupon-template",
    path: "/coupon/template",
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/pages/coupon/template.vue")
  },
  {
    name: "bookstore-data-room",
    path: "/bookstore/data-room",
    meta: data_45roomqZ4oSdqA01rQTESir3xUbTGAbw8xblXgv1sjBDY0XlwMeta || {},
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-ingang/pages/bookstore/data-room.vue")
  },
  {
    name: "bookstore-form",
    path: "/bookstore/form",
    meta: formCcxderkbgHn_AjRh8H_ZFOh3ptSh2ZbHopv1RF2vkjQMeta || {},
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-ingang/pages/bookstore/form.vue")
  },
  {
    name: "bookstore",
    path: "/bookstore",
    meta: indexkERHf50_45Lxw_Sv_45CEfsAwVYpvbtPo0TifCZHFWUJPdwMeta || {},
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-ingang/pages/bookstore/index.vue")
  },
  {
    name: "users-expired-no",
    path: "/users/expired/:no()",
    meta: _91no_93_45gEmqBHcqiXcp8paZ7xg6UmyeEffu3qcXfLd1_45fpk3AMeta || {},
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-doyac/pages/users/expired/[no].vue")
  },
  {
    name: "users-expired",
    path: "/users/expired",
    meta: indexNQ_45te8oqTBtw3_45VKsxH_0jHVzI_wmBO0xtcdcVaCkbAMeta || {},
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-doyac/pages/users/expired/index.vue")
  },
  {
    name: "users-delmember",
    path: "/users/delmember",
    meta: indexamOsP6_45x3cCXlmoIrBlbRkKaoJs6ZyVGxtfL65ZzKwkMeta || {},
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-doyac/pages/users/delmember/index.vue")
  },
  {
    name: "users-no",
    path: "/users/:no()",
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/pages/users/[no].vue")
  },
  {
    name: "users-blackId",
    path: "/users/blackId",
    meta: blackIdcTeIoNAKLWiIv1k8_452gEATCH3HgeiO9ZIfNv63oKa6oMeta || {},
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-ingang/pages/users/blackId.vue")
  },
  {
    name: "users-blackIp",
    path: "/users/blackIp",
    meta: blackIpXIV71Um4kT8YW0aJxIjFPVyxoQZ36tiEnWXcLVZ5DmsMeta || {},
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-doyac/pages/users/blackIp.vue")
  },
  {
    name: "users-blackIpCapcha",
    path: "/users/blackIpCapcha",
    meta: blackIpCapchapHeT_459Vgqas9J5It7LcV8nCssQGruopXUzdgscbiVZEMeta || {},
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-doyac/pages/users/blackIpCapcha.vue")
  },
  {
    name: "users",
    path: "/users",
    meta: indexSSgsCuuJRMPEnNdMtZxrHTGps14YV95nacSg4SRdQ88Meta || {},
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-doyac/pages/users/index.vue")
  },
  {
    name: "users-loginHistory",
    path: "/users/loginHistory",
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/pages/users/loginHistory.vue")
  },
  {
    name: "users-suspicious",
    path: "/users/suspicious",
    meta: suspiciousz175zu2S9CjXnY4zXKRZChZ_qAa3ot6gnDEEPNTJOoEMeta || {},
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-doyac/pages/users/suspicious.vue")
  },
  {
    name: "users-wrongNumber",
    path: "/users/wrongNumber",
    meta: wrongNumberDt8yWn5rGOs6IdOlVhNIsD430yTQZAmyb5ccilReO1cMeta || {},
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-ingang/pages/users/wrongNumber.vue")
  },
  {
    name: "users-wrongNumberHistory",
    path: "/users/wrongNumberHistory",
    meta: wrongNumberHistoryh6BxkAFwUCjh_IRNEDktnunQ_RBfMRJ52je15lqtDYoMeta || {},
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-ingang/pages/users/wrongNumberHistory.vue")
  },
  {
    name: "upcomingWork",
    path: "/upcomingWork",
    meta: index18NFtVoUAFxA0NqXlWSnBlMphvwJAcOWtpM9La2FtiAMeta || {},
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-doyac/pages/upcomingWork/index.vue")
  },
  {
    name: "toExpense",
    path: "/toExpense",
    meta: indexVAfjRohZKbWTJtUEYu4ihMRHoW6pAHugVFwmMsi83Z0Meta || {},
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-doyac/pages/toExpense/index.vue")
  },
  {
    name: "test-a",
    path: "/test/a",
    meta: aBHAQwbyz6Ehb4KFE_iYtx9FPdUjQntiBsXXbjk6s0bEMeta || {},
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-doyac/pages/test/a.vue")
  },
  {
    name: "test-b",
    path: "/test/b",
    meta: bcD4UqvmHK46YUjSlv1bTKmIP5_wiEk_8I3ZRwnpdxmsMeta || {},
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-doyac/pages/test/b.vue")
  },
  {
    name: "test-ea",
    path: "/test/ea",
    meta: ea08Lwdbw3Ird4meKNkYV2Bn3vWU2sRxcRoeHcsgVixYcMeta || {},
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-doyac/pages/test/ea.vue")
  },
  {
    name: "siteManage-logAdIpGroup",
    path: "/siteManage/logAdIpGroup",
    meta: logAdIpGroupZ2Mt_spFxgZK5L7Z_457yXn671kL4D7RsPLFYvFwA_NjsMeta || {},
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-doyac/pages/siteManage/logAdIpGroup.vue")
  },
  {
    name: "siteManage-logAdVsPay",
    path: "/siteManage/logAdVsPay",
    meta: logAdVsPayIfJK58J0ArrI9wRGpIKNoAmROqGbKpKdWflPZ6KZGRYMeta || {},
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-doyac/pages/siteManage/logAdVsPay.vue")
  },
  {
    name: "siteManage-mongoLog",
    path: "/siteManage/mongoLog",
    meta: mongoLogNT2zbiAONgr7UVeyqSBbiNPMrXweUom2Vsn4DpTaMxoMeta || {},
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-doyac/pages/siteManage/mongoLog.vue")
  },
  {
    name: "siteManage-personalQna",
    path: "/siteManage/personalQna",
    meta: personalQnac22sovHBQpXtMnpdvGJq_45b4MNTF1lsb0o1ZQm0khH2MMeta || {},
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-doyac/pages/siteManage/personalQna.vue")
  },
  {
    name: "siteManage-quickReplies",
    path: "/siteManage/quickReplies",
    meta: quickRepliescl1sO_WgPWNNcR4OWcJlHZi5awKRyDlZymbs5exOZ5AMeta || {},
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-doyac/pages/siteManage/quickReplies.vue")
  },
  {
    name: "siteManage-reviews",
    path: "/siteManage/reviews",
    meta: reviewsuxOB0V9VHlC5Gn0X5h8b_FD8RNSmSj_453OGqpcjGVFicMeta || {},
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-ingang/pages/siteManage/reviews.vue")
  },
  {
    name: "siteManage-serverSchedule",
    path: "/siteManage/serverSchedule",
    meta: serverSchedule1sBG_45HFtQxD7mqpPI83ZhDSIceIf2RUgyJ3LWA6oLRYMeta || {},
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-ingang/pages/siteManage/serverSchedule.vue")
  },
  {
    name: "siteManage-serverSetting",
    path: "/siteManage/serverSetting",
    meta: serverSettingDyN6IPXusapuTr_fC1e3KEf_45Sy_45hPlMF7B6eX70DdskMeta || {},
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-ingang/pages/siteManage/serverSetting.vue")
  },
  {
    name: "research-typedPk-questions",
    path: "/research/:typedPk()/questions",
    meta: questionsyO5IE4zvSqb7KWwHTYUYsH9dtsfy_45y72GWmoeZ6_xEMMeta || {},
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-doyac/pages/research/[typedPk]/questions.vue")
  },
  {
    name: "research",
    path: "/research",
    meta: indexZe3_WMvkwIdgcpaeIViU6ZD_45fDoR4_bE9cKbbkILkSUMeta || {},
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-doyac/pages/research/index.vue")
  },
  {
    name: "reminder",
    path: "/reminder",
    meta: indexqqm1qny5yuazBah3jqBy1mR3PKxOh7Nf2EkimuQYAsAMeta || {},
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-doyac/pages/reminder/index.vue")
  },
  {
    name: "payments-table-no",
    path: "/payments/:table()/:no()",
    meta: _91no_93x7tg8lIuoVKox0AvQ_1sP8agLnRLotRAMyvCAQeFC3UMeta || {},
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-ingang/pages/payments/[table]/[no].vue")
  },
  {
    name: "payments-table",
    path: "/payments/:table()",
    meta: indexVZSDkdYjJ9gn8W3Rlu1JUZ79anMp7zb_GsGZJucoLmwMeta || {},
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-ingang/pages/payments/[table]/index.vue")
  },
  {
    name: "payments-shops-no",
    path: "/payments/shops/:no()",
    meta: _91no_93YfYCBlXFhdrbeHREAYlixyAtObMnIb6DLmt8CNQ8ufAMeta || {},
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-ingang/pages/payments/shops/[no].vue")
  },
  {
    name: "payments-shops",
    path: "/payments/shops",
    meta: indexrvOT0_K7PlELjIASsRz21AXf9rx9dgsyB_454ayXQvrB4Meta || {},
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-ingang/pages/payments/shops/index.vue")
  },
  {
    name: "payments-licenses-judgement-no",
    path: "/payments/licenses-judgement/:no()",
    meta: _91no_93QNKxTLTWcfPxuZKKBiUs9t9poC_45tI7hSBHgikdeaeMMMeta || {},
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-ingang/pages/payments/licenses-judgement/[no].vue")
  },
  {
    name: "payments-licenses-no",
    path: "/payments/licenses/:no()",
    meta: _91no_93SWktAPsUQ_4551fRCwUwXItokIH6XDR3lS4FETMaSenhUMeta || {},
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-ingang/pages/payments/licenses/[no].vue")
  },
  {
    name: "payments-licenses",
    path: "/payments/licenses",
    meta: indexcjoXzWHL0agJw6_f2NyuZjGEn1SskS3ng30xB_45FE7qQMeta || {},
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-ingang/pages/payments/licenses/index.vue")
  },
  {
    name: "payments-courses-no",
    path: "/payments/courses/:no()",
    meta: _91no_93rXbIdbHhLX4WKmt50DwI2ZdrnrgNAKIIoL_45t3_45SqZWgMeta || {},
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-ingang/pages/payments/courses/[no].vue")
  },
  {
    name: "payments-courses",
    path: "/payments/courses",
    meta: index7rqxuJMzJujpdHfN6MRyT1Wm_P_45AGJ0JuBbXd6jHCu4Meta || {},
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-ingang/pages/payments/courses/index.vue")
  },
  {
    name: "payments-books-no",
    path: "/payments/books/:no()",
    meta: _91no_93JCtq4XN0eez6dHRcd1adFvcw00b9yv4aI73p2NyZ9QkMeta || {},
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-ingang/pages/payments/books/[no].vue")
  },
  {
    name: "payments-books",
    path: "/payments/books",
    meta: index5MdK_gUhFUTetD_ZCTDWva2dshEE7Ykt10XAdVBSqsoMeta || {},
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-ingang/pages/payments/books/index.vue")
  },
  {
    name: "payments-manual-payments-no",
    path: "/payments/manual-payments/:no()",
    meta: _91no_938Z2fBoz_45DtYD1AC9B6olWgeYL9B3TwLHVLHc9AVyTw8Meta || {},
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-doyac/pages/payments/manual-payments/[no].vue")
  },
  {
    name: "payments-manual-payments",
    path: "/payments/manual-payments",
    meta: indexqz014EHP6j5atjL6EdHoUf4NfPmx4ulB8vRIoC3BgvEMeta || {},
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-doyac/pages/payments/manual-payments/index.vue")
  },
  {
    name: "payments-deposit",
    path: "/payments/deposit",
    meta: index2YlMR7FKgCoed32ky62twNDAcU020TCLvYrD_45bLixFQMeta || {},
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-doyac/pages/payments/deposit/index.vue")
  },
  {
    name: "payments-coupang",
    path: "/payments/coupang",
    meta: index6dtt_NFoGQeI2Smr_45lvTkdJ8zKMg1K0NM6zzYCFu_456gMeta || {},
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-doyac/pages/payments/coupang/index.vue")
  },
  {
    name: "payments-cash-receipts",
    path: "/payments/cash-receipts",
    meta: index8ZCU4RpzNH12TuD05xFFAGfzrELtyUfrlfnZjXD3xy0Meta || {},
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-doyac/pages/payments/cash-receipts/index.vue")
  },
  {
    name: "payments-help-request",
    path: "/payments/help-request",
    meta: help_45requestFAYl0qIBk0wJVCFr_Yp_n4KzaqG0NHeK7EDvE3adXsQMeta || {},
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-doyac/pages/payments/help-request.vue")
  },
  {
    name: "payments-openBellList",
    path: "/payments/openBellList",
    meta: openBellListmCxC5jmBTWyeelz8nQJHFl0xU4Bw99bF871TdKkszWkMeta || {},
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-ingang/pages/payments/openBellList.vue")
  },
  {
    name: "p1-p2",
    path: "/p1/p2",
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-doyac/pages/p1/p2/index.vue")
  },
  {
    name: "p1",
    path: "/p1",
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-doyac/pages/p1/index.vue")
  },
  {
    name: "message",
    path: "/message",
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/pages/message/index.vue")
  },
  {
    name: "mail",
    path: "/mail",
    meta: indexaRbAK4kTDA2Oy9sdY9if__G0B3cUfQd3SbqY5zLuDcQMeta || {},
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-doyac/pages/mail/index.vue")
  },
  {
    name: "mail-write",
    path: "/mail/write",
    meta: writeiNuamx4H1e1hOt5Te0kweKkZoPIXO7_454b76wp2_RR5sMeta || {},
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-doyac/pages/mail/write.vue")
  },
  {
    name: "login-scope",
    path: "/login/:scope()",
    meta: _91scope_93CJCsZF3lC96cesb9WoHt_45XYZIjirdNMpN8cIk7n7LAEMeta || {},
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-doyac/pages/login/[scope].vue")
  },
  {
    name: "login",
    path: "/login",
    meta: index2M8M8_J3EJjSGw4LIFEmCRGeyYpt4GA7cATGQ96MkuQMeta || {},
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-doyac/pages/login/index.vue")
  },
  {
    name: "holidayManage-id",
    path: "/holidayManage/:id()",
    meta: _91id_93pZemD0W7J2wmqN3zr2Lx9daju_45tEJnT1y5ceA77PZoYMeta || {},
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-doyac/pages/holidayManage/[id].vue")
  },
  {
    name: "holidayManage",
    path: "/holidayManage",
    meta: index1JuHgtc9yWGh49NpInHHaXcv1y5H4MLKawruyANXIckMeta || {},
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-doyac/pages/holidayManage/index.vue")
  },
  {
    name: "engineer-autoEventForStudent",
    path: "/engineer/autoEventForStudent",
    meta: autoEventForStudentVlaUEwLvu8qw9ZSJz2NPUDisP7TUyQCNAwgGIfRf_45cgMeta || {},
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-ingang/pages/engineer/autoEventForStudent.vue")
  },
  {
    name: "engineer-siteSetting",
    path: "/engineer/siteSetting",
    meta: siteSettingbBfJ7rGMFigltEltWEum4O6ObyDhLhLABveeR66riXQMeta || {},
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-doyac/pages/engineer/siteSetting.vue")
  },
  {
    name: "email-inbox-no",
    path: "/email/inbox/:no()",
    meta: _91no_93k4EMQJCpKoDrgNArzip6QLEiEhTbSiiBdi1c6WZZPWoMeta || {},
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-doyac/pages/email/inbox/[no].vue")
  },
  {
    name: "email-inbox",
    path: "/email/inbox",
    meta: indexOj6zfHu9WiSXrkzH5oDihMjBnc0humdC_Rfs7_453eahcMeta || {},
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-doyac/pages/email/inbox/index.vue")
  },
  {
    name: "electronicAuthorization-write-type",
    path: "/electronicAuthorization/write/:type()",
    meta: _91type_93CgKapbyMH4IhL7PbYv3TtYw3Yj_45gA_ZY7u3XdN6yHUAMeta || {},
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-doyac/pages/electronicAuthorization/write/[type].vue")
  },
  {
    name: "electronicAuthorization-no",
    path: "/electronicAuthorization/:no()",
    meta: _91no_93aort42eQ_uM2JMM7M4VARxYJ0dqEJkDO_43qxLuPzwEMeta || {},
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-doyac/pages/electronicAuthorization/[no].vue")
  },
  {
    name: "electronicAuthorization",
    path: "/electronicAuthorization",
    meta: indexqMu9PW_03mNEoNgRroHjZqtKkwZMlg_45AhoA7ee41hlgMeta || {},
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-doyac/pages/electronicAuthorization/index.vue")
  },
  {
    name: "commuteRecord-id",
    path: "/commuteRecord/:id()",
    meta: _91id_93BAFzw5IKLYaZ3lecDhsziulsd99pxExC2UnsxQWmNVYMeta || {},
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-doyac/pages/commuteRecord/[id].vue")
  },
  {
    name: "commuteRecord",
    path: "/commuteRecord",
    meta: indexyOj8kJDUC1dYFxW06AKCrIiI7wn6kLMe68iyoBd24MwMeta || {},
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-doyac/pages/commuteRecord/index.vue")
  },
  {
    name: "calendar-no",
    path: "/calendar/:no()",
    meta: _91no_93oEeyW390FhUwGPmytD9WzyGLkTFxWbYTTZlH_U5OslQMeta || {},
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-doyac/pages/calendar/[no].vue")
  },
  {
    name: "aiProposal-no",
    path: "/aiProposal/:no()",
    meta: _91no_93Tw_p_45OPvGhsnyJUI0s4VNAZ2Ak9P6s4u6N1aV7rzf04Meta || {},
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-doyac/pages/aiProposal/[no].vue")
  },
  {
    name: "aiProposal",
    path: "/aiProposal",
    meta: index_451m_hmVA9J6mHPS2OsPHWsKGITTs4LRelZvZz082wtwMeta || {},
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-doyac/pages/aiProposal/index.vue")
  },
  {
    name: "admin-notice-no",
    path: "/admin/notice/:no()",
    meta: _91no_93JfgA_cuu6TrbKTHeyc6YA_45tVECy6zTOZpoiInnqIcjMMeta || {},
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-doyac/pages/admin/notice/[no].vue")
  },
  {
    name: "admin-notice-form",
    path: "/admin/notice/form",
    meta: form1ogCCvznW2C6oja7i3TRV5H1F3MGUi_Vt12j48dOWnUMeta || {},
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-doyac/pages/admin/notice/form.vue")
  },
  {
    name: "admin-notice",
    path: "/admin/notice",
    meta: indexsylDSRXirWXB6_456fyJvwBdmpaptEMUb_451ArgGqX5S_kMeta || {},
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-doyac/pages/admin/notice/index.vue")
  },
  {
    name: "admin-boardManager",
    path: "/admin/boardManager",
    meta: boardManagerKvaqeMIQVWSHqY_gjuxrthBaXv83lp3bdQkbdyjfCrkMeta || {},
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-doyac/pages/admin/boardManager.vue")
  },
  {
    name: "admin-boardRanking",
    path: "/admin/boardRanking",
    meta: boardRankingt_XWRGpAr3_45lka3oJMvVx3sI3yOMTvcJrDCCVxnoukkMeta || {},
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-doyac/pages/admin/boardRanking.vue")
  },
  {
    name: "ai",
    path: "/ai",
    meta: ai5aPSvHlOnXf5f7QHj5kjIXEITv_WRRSdp3njquU0JgEMeta || {},
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-doyac/pages/ai.vue")
  },
  {
    name: "app-bugs",
    path: "/app-bugs",
    meta: app_45bugs4t9m18XtUyH_45_45bT4d4TL3MSdERsK6h3EM2eafwfz9BMMeta || {},
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-ingang/pages/app-bugs.vue")
  },
  {
    name: "banners",
    path: "/banners",
    meta: banners8z5lxyDIPVdHUWzIG4xjfudGLSgvAfJ9trgzZr_45B9kUMeta || {},
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-doyac/pages/banners.vue")
  },
  {
    name: "bugs",
    path: "/bugs",
    meta: bugsm00pKnhJTvLv22mZKNmUYTF9vMAHln8Jpvys_450rNyckMeta || {},
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-ingang/pages/bugs.vue")
  },
  {
    name: "error",
    path: "/error",
    meta: errorawbGuZ9JxL8f3kUBGFHheYC6UtFJiAal2RPf4TIJkGYMeta || {},
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/modules/nuxt3-module-admin-doyac/pages/error.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexYVeA_s0_KaLd_LN4FKvb_45NG15bBj7wNZTqKfyfpOfY8Meta || {},
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/pages/index.vue")
  },
  {
    name: "users-no",
    path: "/users/:no()",
    meta: _91no_93NlCN_45MbjzuiH7VLMfjpVPunqVCeVkKOsTVpuET0GooAMeta || {},
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/pages/users/[no].vue")
  },
  {
    name: "cities-info",
    path: "/cities/info",
    meta: infob_45AqWMOhag8i1dRMlQiwY1wCS7tL8tYfaM0aTMg9J6AMeta || {},
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/pages/cities/info.vue")
  },
  {
    name: "emailAccount",
    path: "/emailAccount",
    meta: emailAccountaQ7Ip0UF72mG0lYCQiG4FNeOG35TTUWYK5fNW0N6bBoMeta || {},
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/pages/emailAccount.vue")
  },
  {
    name: "sales-course",
    path: "/sales/course",
    meta: courseGOn9f770E3ocj9W7uBzmveYkp5_3tCE67DViGNxyUXgMeta || {},
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/pages/sales/course.vue")
  },
  {
    name: "coupon-issued",
    path: "/coupon/issued",
    meta: issuedJw17mLpRD1nClxyhQhhWAHoNaxecUUNpJq819wN1OP8Meta || {},
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/pages/coupon/issued.vue")
  },
  {
    name: "message",
    path: "/message",
    meta: index96HuUAvx_KSaIMUfnZtOLWvJ2GouGd47MbSWLqkSNrcMeta || {},
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/pages/message/index.vue")
  },
  {
    name: "nations",
    path: "/nations",
    meta: indexF5wmmFvK2k9PlsIY6gIEX0GdQiiRzCtbgjliqnrxW_AMeta || {},
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/pages/nations/index.vue")
  },
  {
    name: "tourguide-maps",
    path: "/tourguide/maps",
    meta: mapsaTwXh8CRci_7tD5g_45agcfUPtXsna3258f2OcoKOAruQMeta || {},
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/pages/tourguide/maps.vue")
  },
  {
    name: "coupon-template",
    path: "/coupon/template",
    meta: templateI4wdQEHkll5TkMscmJyGT_6ul7WNC30NJJCdJBpbA1MMeta || {},
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/pages/coupon/template.vue")
  },
  {
    name: "info-urls",
    path: "/info-urls",
    meta: indexP2EiL0FR6l7_1WahFdxL7_45u9XsbSlyEd_45yRSX4ditVEMeta || {},
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/pages/info-urls/index.vue")
  },
  {
    name: "tourguide-city",
    path: "/tourguide/:city()",
    meta: _91city_9338Kyg9GlOGCNobvEYs33NJbJbfzYzpcKxjWe_mhbKgAMeta || {},
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/pages/tourguide/[city].vue")
  },
  {
    name: "cities-isoCode2",
    path: "/cities/:isoCode2()",
    meta: _91isoCode2_93AjSIzW2N8L_hy_YqGa_45b7cz8UWivQLSBYoMElG2NAqkMeta || {},
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/pages/cities/[isoCode2].vue")
  },
  {
    name: "tour-shares",
    path: "/tour-shares",
    meta: index1kuNrnlIvHvHIsgKMZawUinHX3Q7UIaTu0E4L9ci45AMeta || {},
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/pages/tour-shares/index.vue")
  },
  {
    name: "change-infos",
    path: "/change-infos",
    meta: indexByCz3P1bwkipX1RnCLGGh2Pihd5cgwD063KdkBC_45dAcMeta || {},
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/pages/change-infos/index.vue")
  },
  {
    name: "users-loginHistory",
    path: "/users/loginHistory",
    meta: loginHistoryn9cdKDf9VbjszTTCB_fyCPa8epO2G4O7NGwG6FUvPHwMeta || {},
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/pages/users/loginHistory.vue")
  },
  {
    name: "route-reports",
    path: "/route-reports",
    meta: indexA8VREIJGm8VkeucRFERn2jFVdIdRRx2PWo3go7GitCIMeta || {},
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/pages/route-reports/index.vue")
  },
  {
    name: "payments-tickets-no",
    path: "/payments/tickets/:no()",
    meta: _91no_93ugRDf3bK3VeagjFfv9aeic4gfYbVIEIYRp7wcC4vYJUMeta || {},
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/pages/payments/tickets/[no].vue")
  },
  {
    name: "payments-tickets",
    path: "/payments/tickets",
    meta: indexyqaQxnSZP8OVcr1ljoFQS_EiJAO7lMl07EJY7kVGsZYMeta || {},
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/pages/payments/tickets/index.vue")
  },
  {
    name: "tourguide-write-city",
    path: "/tourguide/write/:city()",
    meta: _91city_93uLe4C6FMlZr2wB4wTE7OCxRG2nhhIY9U6IT_45yBYSvkgMeta || {},
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/pages/tourguide/write/[city].vue")
  },
  {
    name: "course-package-typedPk",
    path: "/course/package/:typedPk()",
    meta: _91typedPk_93etrMvqjjHo5l2_45TkLikm_3_5WJc80YNNjxJp1q65bH8Meta || {},
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/pages/course/package/[typedPk].vue")
  },
  {
    name: "payments-gift-orders-no",
    path: "/payments/gift-orders/:no()",
    meta: _91no_93yIRPKGQETJvfwuF6juixhwVxVBw_aphASa_45QLCnedc4Meta || {},
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/pages/payments/gift-orders/[no].vue")
  },
  {
    name: "payments-tour-guides-no",
    path: "/payments/tour-guides/:no()",
    meta: _91no_93Dqwgv8_45ACeOYDWl7ExRo47oWbhMrv_UrxzNq9NP7owMMeta || {},
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/pages/payments/tour-guides/[no].vue")
  },
  {
    name: "payments-gift-orders",
    path: "/payments/gift-orders",
    meta: index1o8g9R9LECvgOM6_45WWjWY6LdKdpbZBKyVgPi1qWo6p0Meta || {},
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/pages/payments/gift-orders/index.vue")
  },
  {
    name: "payments-tour-guides",
    path: "/payments/tour-guides",
    meta: indexPwMxCm8FkzxSIylm03yF9SNUx6iZMEu0nZBbgzDD5a8Meta || {},
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/pages/payments/tour-guides/index.vue")
  },
  {
    name: "ticket-product-frames-no",
    path: "/ticket-product-frames/:no()",
    meta: _91no_93Z9c_w_454HvLHyA6zu5hMf8TzXmobCVGjBeakjx6rcd_8Meta || {},
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/pages/ticket-product-frames/[no].vue")
  },
  {
    name: "tourguide-pds-contentsNo",
    path: "/tourguide/pds/:contentsNo()",
    meta: _91contentsNo_93x8187iQGZMGpLzhupCmJKjHo3ZXWhWgIbCCJqtTYGoQMeta || {},
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/pages/tourguide/pds/[contentsNo].vue")
  },
  {
    name: "tourguide-thirdParty",
    path: "/tourguide/thirdParty",
    meta: indexv322BXpCAOjT_6Uw1eQRP1xJ26lSiBJgbIwl7kvy0D8Meta || {},
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/pages/tourguide/thirdParty/index.vue")
  },
  {
    name: "ticket-product-contents-new",
    path: "/ticket-product-contents/new",
    meta: new8GVPS9cZp_45f6pvZzPE7_45VJmZNXOi_DUQAbVjPylkmwgMeta || {},
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/pages/ticket-product-contents/new.vue")
  },
  {
    name: "ticket-product-frames",
    path: "/ticket-product-frames",
    meta: indexdyNidm6yKvoCuiXIMaeMBLdhRHD377elV8cdQAGqKTMMeta || {},
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/pages/ticket-product-frames/index.vue")
  },
  {
    name: "ticket-product-contents-no",
    path: "/ticket-product-contents/:no()",
    meta: _91no_93kZfoGH2jOCq8nfXUBijpmSOqM9LdpdRb006lpE8LG8YMeta || {},
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/pages/ticket-product-contents/[no].vue")
  },
  {
    name: "tourguide-route-contentsNo",
    path: "/tourguide/route/:contentsNo()",
    meta: _91contentsNo_938QlCc6LvJYMpFV4QVOfBPZcYhVV_hMlx5R8FQRbiLTYMeta || {},
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/pages/tourguide/route/[contentsNo].vue")
  },
  {
    name: "tourguide-write-contents-no",
    path: "/tourguide/write/contents/:no()",
    meta: _91no_93qTuVVOZETCnwuXwmVmWMW6h0_45fAlnrHYOMcfTjGjjuIMeta || {},
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/pages/tourguide/write/contents/[no].vue")
  },
  {
    name: "tourguide-thirdParty-typedPk",
    path: "/tourguide/thirdParty/:typedPk()",
    meta: _91typedPk_9353j2KLnA75d23adkTD1mETfWShAnNxa9aoFzxVKabk4Meta || {},
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/pages/tourguide/thirdParty/[typedPk].vue")
  },
  {
    name: "tourguide-write-route-contentsNo",
    path: "/tourguide/write/route/:contentsNo()",
    meta: _91contentsNo_933x9Tn1ARKCNLguGHjZKqNjayGY_45QrLjBzu6L01Rc6osMeta || {},
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/pages/tourguide/write/route/[contentsNo].vue")
  },
  {
    name: "design-designCustomized-type-pk",
    path: "/design/designCustomized/:type()/:pk()",
    meta: _91pk_93Ex3VaSSh3ZOUD__45XtWgZz7W2pViGQipswGPQBRqIy0IMeta || {},
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/pages/design/designCustomized/[type]/[pk].vue")
  },
  {
    name: "design-designCustomized-form-type-pk",
    path: "/design/designCustomized/form/:type()/:pk()",
    meta: _91pk_939dlrz_NQ0I1xkRsy2pUWzZQq7s4oiDTBUeMneWkx1HIMeta || {},
    component: () => import("D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/pages/design/designCustomized/form/[type]/[pk].vue")
  }
]